import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { unlinkCrowdCell } from '@api/manageCrowdCells';

import { ILinkCrowdCellDTO } from '@interfaces/crowdcell/dto/linkSiteDTO';

import { ESnackbarTypes } from '@enums/common';

import { CROWDCELLS, SITE_PROFILE, UNLINK_CROWDCELL } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUnlinkCrowdCell = (onSettledCallbacks?: Array<() => void>) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleUnlinkCrowdCell,
		isLoading: isLoadingUnlinkCrowdCell,
	} = useMutation<ILinkCrowdCellDTO>({
		mutationKey: [UNLINK_CROWDCELL],
		mutationFn: unlinkCrowdCell,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.unlinkCrowdCellFromSite,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([CROWDCELLS]),
				queryClient.invalidateQueries([SITE_PROFILE]),
			];
		},
	});

	return {
		handleUnlinkCrowdCell,
		isLoadingUnlinkCrowdCell,
	};
};
